import RegisterUserInterface from "@app/Interface/RegisterUserInterface";

export default class RegisterUserModel implements RegisterUserInterface {
    emailAddress: string;
    fpuID: number;
    fpuRoles: string[];
    
    constructor() {
        this.emailAddress = "";
        this.fpuID = 0;
        this.fpuRoles = [];
    }
}